type Dimensions = {
  width: number;
  height: number;
};

export const isFillAlignToWidth = (
  imDim: Dimensions,
  fillDim: Dimensions
): boolean => {
  if (imDim.height === 0 || fillDim.height === 0) {
    return false;
  }

  return !!(imDim.width / imDim.height < fillDim.width / fillDim.height);
};
